import { observer } from 'mobx-react-lite'
import { ReactElement, useEffect } from 'react'
import { I18n, Translate } from 'common'
import { useUiStateStore } from '../../../../../src/store/uiState/UiStateStore'
import BaseDrawer from 'src/ui-components/modals/BaseDrawer'
import styled from 'styled-components'
import { Spinner } from 'react-bootstrap'
import { Box } from '@mui/material'
import { SelectManufaturersTable } from './SelectManufaturersTable'
import { useResultsStore } from '../../store/ResultsStore'

export const SelectLinesDrawer = observer((): ReactElement => {
  const { showFilterLinesDrawer, setShowFilterLinesDrawer } = useUiStateStore()
  const {
    linesManufacturersData,
    getLinesManufacturersData,
    linesManufacturersDataLoading,
    searchResults: { partsBinId },
  } = useResultsStore()

  useEffect(() => {
    if (showFilterLinesDrawer) {
      getLinesManufacturersData()
    }
  }, [getLinesManufacturersData, partsBinId, showFilterLinesDrawer])

  const drawerBody = linesManufacturersDataLoading ? (
    <Box display="flex" justifyContent="center">
      <Spinner animation="border" />
    </Box>
  ) : (
    <>
      <TitleWrapper>
        <I18n name="selectManufactureLines" />
        <I18n name="selectManufacturersUpto" style={{ fontWeight: 'bold' }} />
      </TitleWrapper>

      <SelectManufaturersTable
        linesManufacturersData={linesManufacturersData}
      />
    </>
  )

  return (
    <BaseDrawer
      open={showFilterLinesDrawer}
      title={Translate('filterSelectLines')}
      onClose={() => setShowFilterLinesDrawer(false)}
      body={drawerBody}
      width="550px"
    />
  )
})

SelectLinesDrawer.displayName = 'SelectLinesDrawer'

const TitleWrapper = styled.span``
